{
	"title": "Чаты",
	"newChat": "Новый чат",
	"messageActions": {
		"label": "Действия по ответу",
		"flashcards": "Открыть карточки",
		"quiz": "Открыть тест",
		"material": "Открыть материал",
		"planSubsection": "Открыть в плане",
		"note": "Открыть конспект",
		"plan": "Открыть план",
		"collection": "Открыть папку",
		"saveToArtifacts": "Сохранить в артефакты",
		"savedTooltip": "Уже в артефактах",
		"savingTitle": "Сохранение…",
		"saveSuccess": "Сохранено в артефакты",
		"saveOpen": "Открыть",
		"saveFailed": "Не удалось сохранить ответ"
	},
	"chatList": {
		"title": "История",
		"empty": "Нет чатов"
	},
	"modes": {
		"regular": "Обычный",
		"regularDescription": "Общий AI-чат",
		"materials": "По материалам",
		"materialsDescription": "Отвечает на основе ваших материалов",
		"webSearch": "Веб-поиск",
		"webSearchDescription": "С актуальными данными из интернета"
	},
	"modeChange": {
		"title": "Сменить режим?",
		"hint": "Смена режима повлияет на следующие ответы. История сохранится.",
		"cancel": "Отмена",
		"confirm": "Сменить"
	},
	"sessions": {
		"subtitle": "{count} чатов · {used}/{limit} тыс. токенов",
		"scenarios": "Сценарии",
		"skills": "Навыки",
		"searchPlaceholder": "Поиск по чатам...",
		"messageCount": "{count} сообщ.",
		"noPreview": "Нет сообщений",
		"untitled": "Без названия",
		"dateGroups": {
			"today": "Сегодня",
			"yesterday": "Вчера",
			"week": "На этой неделе",
			"older": "Раньше"
		},
		"filters": {
			"all": "Все"
		},
		"menu": {
			"label": "Действия с чатом",
			"rename": "Переименовать",
			"export": "Экспорт"
		},
		"empty": {
			"title": "Здесь будут твои чаты",
			"hint": "AI знает твои материалы — спроси что угодно по конспекту, лекции или теме.",
			"start": "Начать чат",
			"todayPlan": "Что мне поделать сегодня?",
			"todayPlanPrompt": "Что мне поделать сегодня? Составь персональный план на основе моих материалов, повторений и плана обучения."
		},
		"emptyFilter": {
			"title": "Ничего не нашли по фильтрам",
			"hint": "Сбрось фильтры или попробуй другой запрос"
		},
		"error": {
			"title": "Не удалось загрузить чаты",
			"retry": "Повторить"
		},
		"subtitleNoLimit": "{count} чатов"
	},
	"chat": {
		"back": "Назад",
		"settings": "Настройки чата",
		"scrollToBottom": "Прокрутить вниз",
		"actions": {
			"rename": "Переименовать",
			"export": "Экспорт",
			"delete": "Удалить",
			"menu": "Действия с чатом",
			"renameSuccess": "Чат переименован",
			"renameError": "Не удалось переименовать",
			"renameTitle": "Переименовать чат",
			"renameDesc": "Новое название будет видно в списке чатов.",
			"renamePlaceholder": "Название чата",
			"exportEmpty": "В чате пока нет сообщений",
			"deleteSuccess": "Чат удалён",
			"deleteError": "Не удалось удалить чат",
			"deleteTitle": "Удалить чат?",
			"deleteDesc": "Чат попадёт в корзину на 30 дней."
		},
		"empty": {
			"title": "Начни разговор с репетитором",
			"hint": "Выбери режим выше и задай первый вопрос. AI знает твои материалы.",
			"starters": {
				"explain": "Объясни тему простыми словами — уточни, о чём речь",
				"compare": "Сравни два подхода",
				"solve": "Помоги решить задачу"
			},
			"startersMaterials": {
				"mainIdea": {
					"label": "Объясни главную идею",
					"prompt": "Объясни главную идею этого материала простыми словами."
				},
				"summary": {
					"label": "Краткое содержание",
					"prompt": "Сделай краткое содержание материала в 5 предложениях."
				},
				"keyTerms": {
					"label": "Ключевые термины",
					"prompt": "Назови ключевые термины из этого материала и кратко объясни каждый."
				},
				"remember": {
					"label": "Что важно запомнить",
					"prompt": "Что в этом материале важнее всего запомнить? Выдели главное."
				}
			},
			"todayPlan": "Что мне поделать сегодня?",
			"todayPlanPrompt": "Что мне поделать сегодня? Составь персональный план на основе моих материалов, повторений и плана обучения."
		},
		"followUp": {
			"groupLabel": "Подсказки",
			"explainSimpler": {
				"label": "Объясни проще",
				"prompt": "Объясни предыдущий ответ проще, как для школьника.",
				"promptMaterials": "Объясни главную идею этого материала проще, как для школьника. Опирайся на источники."
			},
			"examples": {
				"label": "Приведи примеры",
				"prompt": "Приведи несколько конкретных примеров к предыдущему ответу.",
				"promptMaterials": "Приведи несколько конкретных примеров из этого материала по ключевым идеям."
			},
			"goDeeper": {
				"label": "Глубже",
				"prompt": "Разбери предыдущий ответ глубже: важные нюансы и связи.",
				"promptMaterials": "Разбери тему материала глубже: важные нюансы и связи. Опирайся на источники."
			}
		},
		"error": {
			"title": "Не удалось получить ответ",
			"retry": "Повторить",
			"regenerate": "Не удалось перегенерировать ответ",
			"editMessage": "Не удалось сохранить правку",
			"deleteMessage": "Не удалось удалить сообщение",
			"createSession": "Не удалось создать чат. Попробуй ещё раз.",
			"updateMode": "Не удалось сменить режим",
			"updateScenario": "Не удалось обновить сценарий",
			"updateSkills": "Не удалось обновить навыки"
		},
		"export": {
			"user": "Пользователь",
			"assistant": "Репетитор"
		},
		"autoExplainTopic": "Объясни тему: «{topic}». Где я ошибаюсь и на что обратить внимание?",
		"offlineWrite": "Нет сети — отправка и создание требуют подключения.",
		"offlineAttachments": "Вложения нельзя отправить в офлайн-режиме",
		"streamBusy": "Дождись окончания ответа, затем подтверди действие."
	},
	"stream": {
		"queued": "В очереди...",
		"retrieving": "Подбираю контекст по материалам...",
		"found": "Найдено {chunks} фрагментов из {sources} материалов",
		"generating": "Генерирую ответ...",
		"toolCallingStudyState": "Смотрю учебное состояние...",
		"toolCallingPlan": "Смотрю учебный план...",
		"toolCallingCreateArtifact": "Создаю материал...",
		"toolCallingDefault": "Выполняю действие...",
		"toolCalling": {
			"study_state": "Смотрю учебное состояние...",
			"plan_tasks": "Смотрю учебный план...",
			"get_study_plans": "Загружаю учебные планы...",
			"create_artifact": "Создаю материал...",
			"create_plan": "Собираю учебный план...",
			"manage_plan": "Обновляю учебный план...",
			"get_collections": "Загрузка папок...",
			"manage_collection": "Обновление папки...",
			"generate_from_collection": "Генерация из папки...",
			"search_library": "Ищу в библиотеке...",
			"add_material": "Добавляю материал...",
			"retry_material": "Повторяю обработку материала...",
			"generate_audio_recap": "Запускаю аудио-резюме...",
			"start_essay": "Создаю черновик эссе...",
			"submit_essay": "Отправляю эссе...",
			"open_voice": "Готовлю голосовой репетитор...",
			"open_audio": "Готовлю аудио-резюме...",
			"practice_weak_spot": "Готовлю практику по слабой теме...",
			"export_glossary": "Экспортирую глоссарий в карточки...",
			"regenerate_note": "Регенерирую конспект...",
			"note_ai_block": "Работаю с AI-блоком конспекта...",
			"progress_snapshot": "Смотрю прогресс...",
			"manage_calendar": "Обновляю календарь...",
			"streak_state": "Смотрю стрик...",
			"use_streak_freeze": "Готовлю заморозку стрика...",
			"notes_catalog": "Ищу конспекты...",
			"quiz_catalog": "Ищу тесты...",
			"recordings_catalog": "Ищу записи...",
			"topic_context": "Читаю материалы темы...",
			"open_flashcard_study": "Открываю карточки...",
			"open_quiz_take": "Открываю тест...",
			"undo_last_action": "Отменяю…"
		},
		"cancelled": "(остановлено)",
		"noContext": "В материалах не нашлось релевантного — отвечаю без опоры на них",
		"webSearchSkipped": "Веб-поиск не потребовался — отвечаю из знаний модели",
		"errorTitle": "Не удалось получить ответ",
		"retryable": "можно повторить",
		"errorHint": "Чат ещё не готов. Подожди немного и попробуй снова.",
		"retrievalPlain": "Ищу в материалах...",
		"retrievalQuery": "Ищу:",
		"retrievalContinuation": "Продолжаю тему, ищу новое:",
		"retrievalReveal": "Показать запрос целиком",
		"searched": "Искал:",
		"searchedContinuation": "Продолжил тему:",
		"searchedExpand": "Показать запрос целиком",
		"searchedCollapse": "Свернуть запрос",
		"circuitOpenTitle": "ИИ временно недоступен",
		"awaitingPersist": "Ответ всё ещё готовится…",
		"retryAfterSeconds": "повтори через {seconds} с"
	},
	"webSearch": {
		"searching": "Ищу в интернете: «{query}»",
		"found": "Источников: {count}",
		"loading": "Загружаю источники..."
	},
	"composer": {
		"placeholder": "Спросите что угодно…",
		"placeholderMaterial": "Спросите о материале…",
		"placeholderWeb": "Ищи свежие данные в интернете...",
		"send": "Отправить",
		"stop": "Остановить",
		"stopVoice": "Остановить",
		"startVoice": "Голосовой чат",
		"startVoiceHint": "Начать голосовую сессию",
		"voiceInput": "Голосовой ввод",
		"recording": "Запись... (нажми чтобы остановить)",
		"transcribing": "Распознаю…",
		"sttPermissionDenied": "Нет доступа к микрофону",
		"sttNotSupported": "Голосовой ввод не поддерживается в этом браузере",
		"sttEmpty": "Запись пустая — попробуйте ещё раз",
		"sttFailed": "Не удалось распознать речь",
		"sttNoSpeech": "Не удалось расслышать речь",
		"attach": "Прикрепить",
		"tools": "Прикрепить и настроить",
		"attachMaterial": "Прикрепить материал",
		"modifiers": "Сценарии и навыки",
		"image": "Изображение",
		"file": "Файл",
		"material": "Материал",
		"searchMaterials": "Найти материал...",
		"noMaterials": "Не найдено",
		"hint": "Enter — отправить · Shift+Enter — перенос",
		"quotaExceeded": "Лимит исчерпан — обновить план",
		"materialAttached": "Материал прикреплён: {name}",
		"materialAttachFailed": "Не удалось прикрепить материал",
		"attachTooLarge": "Файл больше 20 МБ — попробуйте уменьшить",
		"attachTooLargeTier": "Файл слишком большой для вашего тарифа (на Free — до 10 МБ)",
		"attachTooMany": "Можно прикрепить не больше {max} файлов",
		"attachUnsupported": "Этот тип файла не поддерживается",
		"attachUploadFailed": "Не удалось загрузить файл",
		"attachUploading": "Загрузка…",
		"attachError": "Ошибка загрузки",
		"attachRemove": "Удалить",
		"dropToAttach": "Отпустите, чтобы прикрепить к сообщению",
		"dropFormats": "Изображения, PDF, Word, Excel, текст",
		"modifiersLoading": "Загрузка…",
		"modifiersEmptyScenarios": "Нет сценариев — создай первый",
		"modifiersEmptySkills": "Нет навыков — создай первый",
		"modifiersClear": "Сбросить",
		"modifiersManage": "Управлять",
		"attachTooLargeLimit": "Файл слишком большой для вложения",
		"quotaExceededNoSale": "Лимит сообщений на сегодня исчерпан"
	},
	"voiceInline": {
		"listening": "Слушаю…",
		"speaking": "Говорю…",
		"thinking": "Думаю…",
		"searching": "Поиск материалов…",
		"end": "Завершить запись",
		"muteMic": "Выключить микрофон",
		"muteSpeaker": "Выключить звук",
		"endedContinueText": "Голосовой ввод завершен — продолжите текстом",
		"goAway": "Голосовая сессия завершена — продолжите в текстовом чате",
		"typeIntoLive": "Введите текст…",
		"needSession": "Сначала откройте чат или отправьте сообщение, чтобы начать голосовой ввод",
		"startFailed": "Не удалось запустить голосовой режим",
		"micMuted": "Микрофон выключен",
		"connecting": "Подключение…",
		"micHeldHint": "Микрофон включится после приветствия"
	},
	"message": {
		"you": "Вы",
		"tutor": "Репетитор",
		"thinking": "Думаю…",
		"regenerate": "Перегенерировать",
		"copy": "Скопировать",
		"copied": "Скопировано",
		"copiedToClipboard": "Сообщение скопировано в буфер обмена",
		"copyFailed": "Не удалось скопировать",
		"feedback": {
			"good": "Полезный ответ",
			"bad": "Неточный ответ",
			"failed": "Не удалось отправить оценку"
		},
		"menu": {
			"convertToNote": "Конвертировать в конспект",
			"createFlashcards": "Создать карточки",
			"share": "Поделиться",
			"more": "Ещё действия"
		},
		"sources": "Источники",
		"sourceFromMaterial": "Из материала «{name}»",
		"webSourceLabel": "Из интернета",
		"shareCopied": "Текст ответа скопирован",
		"shareFailed": "Не удалось скопировать",
		"speak": "Озвучить",
		"stopSpeaking": "Остановить озвучку",
		"ttsPlaybackRate": "Скорость воспроизведения {rate}",
		"downloadAudio": "Скачать озвучку",
		"ttsPreparing": "Готовим озвучку…",
		"ttsEmpty": "Нечего озвучить",
		"ttsQuota": "Лимит озвучки исчерпан",
		"ttsFailed": "Не удалось озвучить",
		"ttsDownloadFailed": "Не удалось скачать озвучку",
		"ttsPartial": "Озвучена первая часть ответа",
		"ttsOffline": "Нет сети",
		"ttsMediaTitle": "Ответ репетитора"
	},
	"citations": {
		"groupAria": "{count, plural, one {# источник: {name}} few {# источника: {name}} many {# источников: {name}} other {# источника: {name}}}"
	},
	"citationSheet": {
		"webHeader": "Веб-источник",
		"lectureHeader": "Запись лекции",
		"materialHeader": "Из материала",
		"page": "стр. {n}",
		"openWeb": "Открыть в новой вкладке",
		"openMaterial": "Открыть материал",
		"jumpAudio": "Прыжок к моменту в записи",
		"jumpAudioAt": "Открыть запись с {time}",
		"materialFallback": "материал"
	},
	"voiceMode": {
		"title": "Голосовой режим",
		"start": "Начать разговор",
		"stop": "Завершить",
		"listening": "Слушаю…",
		"speaking": "Говорю…",
		"muted": "Микрофон выключен",
		"mute": "Выключить микрофон",
		"unmute": "Включить микрофон",
		"audioWarning": "Аудио не сохраняется"
	},
	"scenariosPage": {
		"title": "Сценарии",
		"subtitle": "Готовые системные промпты под стиль диалога",
		"create": "Создать",
		"search": "Поиск...",
		"builtin": "Встроенные ({n})",
		"mine": "Мои ({n})",
		"filters": {
			"all": "Все",
			"builtin": "Встроенные",
			"mine": "Мои"
		},
		"empty": {
			"title": "Создай свой сценарий",
			"hint": "Опиши стиль диалога одним системным промптом и переиспользуй для серии чатов.",
			"cta": "Создать"
		}
	},
	"scenarios": {
		"launch": "Запустить",
		"launchHint": "Создать новый чат с этим сценарием",
		"start": "Создать чат",
		"builtinBadge": "Встроенный",
		"edit": "Редактировать",
		"delete": "Удалить",
		"dialog": {
			"createTitle": "Новый сценарий",
			"editTitle": "Редактировать сценарий",
			"subtitle": "Сценарий задаёт системный промпт — стиль и тон диалога для всех чатов с ним.",
			"name": "Название",
			"namePlaceholder": "Например: Сократический диалог",
			"description": "Описание",
			"descriptionPlaceholder": "Короткая подсказка для себя",
			"prompt": "Системный промпт",
			"promptPlaceholder": "Опиши стиль ответов AI — это инструкция для каждого сообщения.",
			"promptHint": "Минимум 10 символов, максимум 8000. Поддерживается markdown."
		},
		"toast": {
			"updated": "Сценарий обновлён",
			"created": "Сценарий создан",
			"saveFailed": "Не удалось сохранить",
			"deleted": "Сценарий удалён",
			"deleteFailed": "Не удалось удалить"
		},
		"deleteConfirm": {
			"title": "Удалить сценарий?",
			"body": "«{name}» попадёт в корзину на 30 дней. Существующие чаты, использующие этот сценарий, продолжат работать без него."
		}
	},
	"skillsPage": {
		"title": "Навыки",
		"subtitle": "Библиотека навыков — короткие инструкции к стилю ответов. Включай их в любом чате через кнопку модификаторов (✦) у поля ввода.",
		"create": "Создать",
		"search": "Поиск...",
		"builtin": "Встроенные",
		"mine": "Мои",
		"empty": {
			"title": "Создай свой навык",
			"hint": "Короткая инструкция, которую можно включить в любом чате с репетитором.",
			"cta": "Создать"
		}
	},
	"skills": {
		"title": "Навыки",
		"explain": "Объясни",
		"quiz": "Опроси меня",
		"summarize": "Сократи",
		"rephrase": "Перефразируй",
		"builtinBadge": "Встроенный",
		"edit": "Редактировать",
		"delete": "Удалить",
		"dialog": {
			"createTitle": "Новый навык",
			"editTitle": "Редактировать навык",
			"subtitle": "Короткая инструкция, которая добавляется к промпту AI при активации навыка.",
			"name": "Название",
			"namePlaceholder": "Например: LaTeX-формулы",
			"description": "Описание",
			"descriptionPlaceholder": "Короткая подсказка для себя",
			"instruction": "Инструкция",
			"instructionPlaceholder": "Например: «Все формулы оборачивай в $$…$$ для рендера LaTeX».",
			"instructionHint": "Минимум 5 символов, максимум 2000."
		},
		"toast": {
			"updated": "Навык обновлён",
			"created": "Навык создан",
			"saveFailed": "Не удалось сохранить",
			"deleted": "Навык удалён",
			"deleteFailed": "Не удалось удалить"
		},
		"deleteConfirm": {
			"title": "Удалить навык?",
			"body": "«{name}» попадёт в корзину на 30 дней."
		}
	},
	"panel": {
		"title": "Репетитор",
		"greetingTitle": "Привет, я репетитор StudyHub",
		"greetingHint": "Спроси что-то по теме или выбери подсказку ниже.",
		"placeholder": "Спроси о теме…",
		"clear": "Очистить чат",
		"close": "Закрыть панель",
		"hint": "Enter — отправить · Shift+Enter — перенос",
		"thinking": "Думаю…",
		"sessionFailed": "Не удалось начать сессию. Попробуй ещё раз.",
		"answerFailed": "Не удалось получить ответ. Попробуй ещё раз.",
		"newChat": "Новый чат",
		"history": "История чатов",
		"historyTitle": "История чатов",
		"back": "Назад",
		"deleteConfirm": "Чат попадёт в корзину на 30 дней.",
		"deleted": "Чат удалён",
		"renamed": "Чат переименован",
		"ariaLabel": "AI-репетитор",
		"sg": {
			"visual": "Создай визуализацию, чтобы я понял эту тему",
			"context": "Дай вводную информацию по теме",
			"hint": "Подскажи, не давая прямого ответа",
			"todayPlan": "Что мне поделать сегодня?"
		},
		"course": {
			"build": {
				"label": "Собрать программу",
				"prompt": "Собери черновик программы курса «{topic}»: раздели на темы и объясни порядок."
			},
			"refine": {
				"label": "Уточнить программу",
				"prompt": "Посмотри на черновик программы по теме «{topic}» и предложи конкретные правки: что изменить по порядку, объединить или переформулировать. По одному изменению за раз с пояснением причин."
			},
			"add": {
				"label": "Чего не хватает?",
				"prompt": "Чего не хватает в курсе «{topic}»? Предложи недостающие темы по одной и объясни, почему они важны."
			},
			"trim": {
				"label": "Убрать лишнее",
				"prompt": "Моя цель — «{goal}». Какие темы из «{topic}» можно исключить без ущерба для результата? Предлагай удалять их по одной."
			},
			"sources": {
				"label": "Найти источники",
				"prompt": "Найди в интернете два-три надежных источника по теме «{topic}» и предложи добавить лучшие в курс."
			}
		},
		"settings": "Настройки панели",
		"historyShort": "История"
	},
	"context": {
		"material": "Чат по материалу «{name}»",
		"materialPlus": "Чат по материалу «{name}» +{count}",
		"materialsCount": "Чат по {count, plural, one {# материалу} few {# материалам} many {# материалам} other {# материалам}}",
		"collection": "Чат по папке «{name}»",
		"collectionPlus": "Чат по папке «{name}» +{count}",
		"collectionsCount": "Чат по {count, plural, one {# папке} few {# папкам} many {# папкам} other {# папкам}}",
		"label": "Контекст",
		"remove": "Убрать из контекста",
		"pending": "«{name}» будет добавлен",
		"dismissPending": "Не добавлять",
		"focusQuestion": "Вопрос {n}/{total}",
		"focusCard": "Карточка {n}/{total}",
		"kind": {
			"material": "Материал",
			"collection": "Папка",
			"recap": "Аудио-резюме",
			"essay": "Эссе",
			"visual": "Разбор по фото",
			"recording": "Запись",
			"voice": "Голосовая сессия"
		}
	},
	"materials": {
		"scope": {
			"title": "Выберите материалы",
			"description": "AI будет искать ответы только в выбранных материалах. Без выбора — поиск по всем материалам.",
			"useAll": "По всем материалам",
			"apply": "Применить"
		},
		"chip": {
			"allMaterials": "По всем материалам",
			"choose": "Выбрать",
			"materialsCount": "{count, plural, one {# материал} few {# материала} many {# материалов} other {# материала}}"
		}
	},
	"artifactCard": {
		"pending": "Создаём {artifact}…",
		"ready": "{artifact} готов",
		"failed": "Не удалось создать",
		"open": "Открыть",
		"retry": "Повторить",
		"quizSummary": "{count, plural, one {# вопрос} few {# вопроса} many {# вопросов} other {# вопроса}}",
		"flashcardsSummary": "{count, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточки}}",
		"glossarySummary": "{count, plural, one {# термин} few {# термина} many {# терминов} other {# термина}}"
	},
	"richCard": {
		"pending": "Выполняется…",
		"ready": "Готово",
		"failed": "Не удалось выполнить",
		"open": "Открыть",
		"undo": "Отменить",
		"confirm": {
			"title": "Подтвердите действие",
			"hint": "Это изменение сложно отменить.",
			"cta": "Подтвердить",
			"cancel": "Отмена",
			"failed": "Не удалось подтвердить действие. Попробуй ещё раз."
		},
		"undoFailed": "Не удалось отменить действие.",
		"machinePrompt": {
			"confirm": "Подтверждение действия",
			"undo": "Отмена действия"
		},
		"kinds": {
			"artifact": "Учебный материал",
			"plan": "Учебный план",
			"collection": "Папка",
			"material": "Материал",
			"action_result": "Результат",
			"confirm": "Подтверждение",
			"progress_summary": "Прогресс",
			"weak_spot": "Слабое место",
			"calendar_event": "Событие",
			"essay": "Эссе",
			"audio_recap": "Аудио-резюме",
			"recording": "Запись",
			"visual": "Визуал"
		}
	},
	"createFrom": {
		"title": "Создать на основе",
		"menuTitle": "Создать на основе чата",
		"notes": "Конспект",
		"flashcards": "Карточки",
		"quiz": "Тест",
		"glossary": "Словарь терминов",
		"voice": "Голосовой разбор",
		"audio": "Аудио-резюме",
		"configureNote": "Настроить конспект…",
		"configureFlashcards": "Настроить карточки…",
		"configureQuiz": "Настроить тест…",
		"generating": "{artifact} · создаётся…",
		"started": "{artifact} создаётся — придёт уведомление",
		"readyTitle": "{artifact} готов",
		"readyOpen": "Открыть",
		"failed": "Не удалось создать {artifact}. Попробуйте ещё раз.",
		"busy": "Уже создаётся материал из этого чата — дождись готовности или попробуй чуть позже.",
		"disabledHint": "Задайте вопрос репетитору, чтобы создать материалы",
		"materializing": "Готовлю материал из диалога…",
		"materializeFailed": "Не удалось подготовить материал из диалога",
		"options": {
			"noteTitle": "Настройки конспекта",
			"noteDesc": "Уровень детальности конспекта из диалога.",
			"detailLevel": "Уровень детальности",
			"detailSummarized": "Краткий",
			"detailInDepth": "Подробный",
			"detailComprehensive": "Исчерпывающий",
			"flashcardsTitle": "Настройки карточек",
			"flashcardsDesc": "Сколько карточек создать из диалога.",
			"flashcardsCount": "Количество карточек",
			"quizTitle": "Настройки теста",
			"quizDesc": "Параметры теста из диалога.",
			"quizCount": "Количество вопросов",
			"quizDifficulty": "Сложность",
			"difficultyEasy": "Лёгкая",
			"difficultyMedium": "Средняя",
			"difficultyHard": "Сложная",
			"difficultyMixed": "Смешанная",
			"create": "Создать",
			"cancel": "Отмена"
		}
	},
	"thoughts": {
		"live": "Размышление… · {count, plural, one {# шаг} few {# шага} many {# шагов} other {# шага}}",
		"summary": "Размышление {seconds}с · {count, plural, one {# шаг} few {# шага} many {# шагов} other {# шага}}",
		"summaryNoTime": "Рассуждение · {count, plural, one {# шаг} few {# шага} many {# шагов} other {# шага}}",
		"toggleAria": "Шаги рассуждения",
		"show": "Показать рассуждение",
		"hide": "Скрыть рассуждение",
		"step": {
			"read": "Прочитано:",
			"readMore": "+{count, plural, one {# ещё} few {# ещё} many {# ещё} other {# ещё}}",
			"noContext": "Отвечаю по общим знаниям",
			"searched": "Поиск:",
			"webSearch": "Поиск в сети:"
		}
	},
	"chatArtifact": {
		"untitled": "Артефакт",
		"openLarge": "Открыть в полном размере",
		"generating": "Инфографика готовится…",
		"failed": "Не удалось создать",
		"retry": "Повторить",
		"retryFailed": "Не удалось перезапустить. Попробуйте позже.",
		"retryPrompt": "Пересоздать инфографику: {title}",
		"emptyDiagram": "В ответе нет диаграммы",
		"urlFailed": "Не удалось загрузить изображение",
		"openLargeOf": "Открыть «{title}» в полном размере"
	},
	"artifactViewer": {
		"untitled": "Артефакт",
		"kind": {
			"diagram": "Диаграмма",
			"infographic": "Инфографика"
		},
		"generatingTitle": "Идет подготовка",
		"generatingHint": "Файл откроется здесь, как только будет готов.",
		"failedTitle": "Не удалось создать",
		"failedHint": "Попробуйте ещё раз на панели артефактов.",
		"emptyDiagram": "Исходные данные диаграммы пусты",
		"urlFailedTitle": "Не удалось открыть файл",
		"urlFailedHint": "Возможно, срок действия ссылки истек — запросите новую.",
		"retry": "Повторить",
		"download": "Скачать",
		"downloadFailed": "Не удалось скачать файл"
	},
	"assets": {
		"imageAlt": "Иллюстрация из материала",
		"openImage": "Открыть изображение"
	},
	"outbox": {
		"dropped": "{count, plural, one {# сообщение не отправлено} few {# сообщения не отправлены} many {# сообщений не отправлены} other {# сообщения не отправлены}}",
		"droppedCopy": "Скопировать текст"
	},
	"terminal": {
		"length": {
			"banner": "Ответ был прерван из-за ограничений по длине.",
			"continue": "Продолжить",
			"continuePrompt": "Продолжить с места остановки."
		},
		"toolLimit": {
			"banner": "Не удалось завершить цепочку инструментов",
			"hint": "Попробуй переформулировать запрос или повторить попытку.",
			"retry": "Повторить",
			"rephrase": "Переформулировать",
			"retryPrompt": "Повтори тот же запрос.",
			"rephrasePrompt": "Сформулируй запрос более конкретно."
		}
	},
	"failedTurn": {
		"hint": "Мы предприняли несколько попыток, но ответа не получили. Твоё сообщение сохранено — можешь попробовать снова.",
		"retry": "Повторить"
	},
	"intro": {
		"title": "Репетитор отвечает и делает",
		"body": "Он читает ваши материалы и по просьбе тут же собирает конспект, карточки, тест или схему — создаёт их в приложении, а не описывает.",
		"bullets": [
			"Отвечает по вашим источникам и ссылается на фрагменты",
			"Ищет в интернете, когда в материалах ответа нет",
			"Рисует схемы и инфографику прямо в переписке"
		]
	}
}
